import { Link, useNavigate, useLocation } from "react-router-dom";
import { Linkedin, Facebook, Instagram, Twitter } from "lucide-react";

const company = [
  { label: "Services", target: "#services" },
  { label: "How It Works", target: "#how-it-works" },
  { label: "About", target: "#about" },
  { label: "Contact", target: "#contact" },
];

const resources = [
  { label: "Methodology", to: "/methodology" },
  { label: "Case Studies", to: "/case-studies" },
  { label: "Resources", to: "/resources" },
  { label: "Blog", to: "/blog" },
];

// [CONFIRM] Replace with real LinkedIn company URL when page is live
const LINKEDIN_URL = "https://linkedin.com/company/arqeraai";

export default function ArqFooter() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (target: string) => {
    if (location.pathname === "/") {
      document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/${target}`);
    }
  };

  return (
    <footer className="bg-arq-bg border-t border-arq-border px-6 py-16">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="font-display font-bold text-arq-text text-[18px] tracking-[0.05em] mb-3">
              ARQERAAI
            </div>
            <p className="text-arq-muted text-[14px] mb-2">AI Feature Security Reviews for Regulated Teams.</p>
            <p className="text-arq-tertiary text-[12px] mb-4">A Batach Global company</p>
            <a
              href="mailto:hello@arqeraai.com"
              className="text-arq-muted text-[14px] hover:text-arq-text transition-colors block mb-4"
            >
              hello@arqeraai.com
            </a>
            <div className="flex items-center gap-2">
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ArqeraAI on LinkedIn"
                className="inline-flex items-center justify-center w-9 h-9 rounded-md border border-arq-border text-arq-muted hover:text-arq-text hover:border-arq-blue transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="https://twitter.com/arqeraai"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ArqeraAI on Twitter"
                className="inline-flex items-center justify-center w-9 h-9 rounded-md border border-arq-border text-arq-muted hover:text-arq-text hover:border-arq-blue transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="https://www.instagram.com/arqeraai/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ArqeraAI on Instagram"
                className="inline-flex items-center justify-center w-9 h-9 rounded-md border border-arq-border text-arq-muted hover:text-arq-text hover:border-arq-blue transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://www.facebook.com/arqeraai"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ArqeraAI on Facebook"
                className="inline-flex items-center justify-center w-9 h-9 rounded-md border border-arq-border text-arq-muted hover:text-arq-text hover:border-arq-blue transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <div className="arq-label mb-4">Company</div>
            <ul className="space-y-2">
              {company.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={() => goToSection(l.target)}
                    className="text-[14px] text-arq-tertiary hover:text-arq-muted transition-colors text-left"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="arq-label mb-4">Resources</div>
            <ul className="space-y-2">
              {resources.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-[14px] text-arq-tertiary hover:text-arq-muted transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="arq-label mb-4">Legal</div>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-[14px] text-arq-tertiary hover:text-arq-muted transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-[14px] text-arq-tertiary hover:text-arq-muted transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-arq-border pt-6 text-center">
          <p className="text-[13px] text-arq-tertiary">© 2026 ArqeraAI LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
